<template>
  <div class="kw_label_row">
    <div class="boxPadding">
      <kw_tabs v-model="oneCurrent" @change="oneClickTab" scroll i-class="firstTabs" :tabsStyleSet="value.styleSet.pageFieldOneTabsStyleSet?value.styleSet.pageFieldOneTabsStyleSet.styleSetCode:''" kwName="pageFieldOneTabsStyleSet">
        <div :class="(value.childPageJsonArr[0].fieldSet[0].childPageJsonArr.lenght>0?'firstTab':'')">
            <kw_tab v-for="(item,index) in value.childPageJsonArr[0].fieldSet[0].childPageJsonArr" :key="'label_one_'+index" :name="item.defaultIdStr" :title="item.fieldSet[0].defaultValStr" :index="item.fieldSet[4].defaultCheckValue" :tabDefaultStyle="value.styleSet.pageFieldOneTabDefaultStyleSet?value.styleSet.pageFieldOneTabDefaultStyleSet.styleSetCode:''" :tabCheckStyle="value.styleSet.pageFieldOneTabCheckStyleSet?value.styleSet.pageFieldOneTabCheckStyleSet.styleSetCode:''" kwName="pageFieldOneTabStyleSet"></kw_tab>
        </div>
      </kw_tabs>
      <div class="hasScrollTip">
        <div style="flex:1 1 auto;overflow: hidden">
          <kw_tabs v-model="twoCurrent" scroll @change="clickTab" :tabsStyleSet="value.styleSet.pageFieldTwoTabsStyleSet?value.styleSet.pageFieldTwoTabsStyleSet.styleSetCode:''" kwName="pageFieldTwoTabsStyleSet">
            <div class="secondTab">
              <kw_tab class="newUpImg" v-for="(twoItem,twoIndex) in value.childPageJsonArr[1].fieldSet[0].childPageJsonArr" :key="'label_two_'+twoIndex" v-if="(oneCurrent == twoItem.fieldSet[1].defaultValStr)" :title="twoItem.fieldSet[0].defaultValStr" :name="twoItem.defaultIdStr" :bgFile="(twoItem.fieldSet[2].defaultValStr?GLOBAL.getFileServeUrl()+twoItem.fieldSet[2].defaultValStr:'././components/look/img/img_1.png')" :fileType="twoItem.fieldSet[3].defaultCheckValue" :tabDefaultStyle="value.styleSet.pageFieldTwoTabDefaultStyleSet?value.styleSet.pageFieldTwoTabDefaultStyleSet.styleSetCode:''" :tabCheckStyle="value.styleSet.pageFieldTwoTabCheckStyleSet?value.styleSet.pageFieldTwoTabCheckStyleSet.styleSetCode:''" kwName="pageFieldTwoTabStyleSet"></kw_tab>
            </div>
          </kw_tabs>
        </div>
        <div class="scrollTipImg" v-if="(identification != 2)">
        <img src="./img/scrollLeftAndRight.png" mode="widthFix"/>
          <div class="more">更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// kw_tabs 标签组组件
import kw_tabs from '@/components/kw/kw_tabs.vue';
// kw_tab 标签组件
import kw_tab from '@/components/kw/kw_tab.vue';

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_label_row',
  props: {
    value: {
      type: Object,
      value: {}
    }
  },
  data() {
    return {
      oneCurrent:"",
      twoCurrent:"",
      //是否显示更多提示
      identification:1
    };
  },
  created() {
    if (this.value.childPageJsonArr.length>0) {
      var oneCurrent = "";  
      var childPageJsonArr = this.value.childPageJsonArr[0].fieldSet[0].childPageJsonArr
      console.log(childPageJsonArr,'+++++++++++++++++++++++++')
      if (childPageJsonArr) {
        oneCurrent = childPageJsonArr[0].defaultIdStr;
      }
      this.oneCurrent = oneCurrent;
    }
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_tabs,
    kw_tab
  },
  methods: {
    oneClickTab(tab, event){ 
      this.identification = '';
      //  console.log("detail================", detail);

      this.oneCurrent=tab.name;
      this.identification=tab.index

    },
    /**
     * 点击时 进行关联的页面打开
     */
    clickTab(tab, event) {
      var clickVal = tab.name;
      var styleSet = this.value.styleSet;
      console.log("tab================", tab);
      var jumpJson = {
        pageId: styleSet.clickPageId,
        tableId: styleSet.clickTableId,
        mainId: clickVal,
        callBackType: 1
      };
      pageUtils.toNewLookPage(this,jumpJson);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.newUpImg img+div{ width: 75px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;font-size: 14px;}
.boxPadding{border: 1px solid #ECECEC;background: #fff;margin: 8px 10px 0;border-radius: 5px;padding: 5px}
.firstTab{border-bottom: 1px solid #ECECEC;padding:5px 10px;border-top-left-radius: 5px;border-top-right-radius: 5px}
 .secondTab{overflow: auto}
.firstTabs{border-top-left-radius: 5px;border-top-right-radius: 5px}

.hasScrollTip {display:flex;align-items: center}
.hasScrollTip .scrollTipImg {flex:0 0 50px;text-align: center;font-size: 14px}
.scrollTipImg img {width:32px;margin-top: 8px}
.hasScrollTip .scrollTipImg .more {font-size: 14px;color: #BABABA;padding: 7px 0 0 0;}
</style>
